/**
 * Component Entry
 *
 */

import Table from './Table'
export default Table
export * from './Table'
